// Toggle the search panel below the nav bar, with focus trap.
import { createFocusTrap } from "./focus-trap.js";

export function setupSearch(navElement) {
  const searchToggle = navElement.querySelector(".mega-nav__search-toggle");
  const searchPanel = navElement.querySelector(".mega-nav__search-panel");
  const searchInput = navElement.querySelector(".mega-nav__search-input");
  const searchClose = navElement.querySelector(".mega-nav__search-close");

  const focusTrap = searchPanel ? createFocusTrap(searchPanel) : null;

  const closeSearch = () => {
    if (!searchPanel) return;
    searchPanel.classList.remove("mega-nav__search-panel--open");
    searchPanel.setAttribute("aria-hidden", "true");
    focusTrap?.deactivate();
  };

  searchToggle?.addEventListener("click", () => {
    if (!searchPanel) return;
    const isOpen = searchPanel.classList.toggle(
      "mega-nav__search-panel--open"
    );
    searchPanel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) {
      setTimeout(() => searchInput?.focus(), 60);
      focusTrap?.activate();
    } else {
      focusTrap?.deactivate();
    }
  });

  searchClose?.addEventListener("click", closeSearch);

  return { closeSearch };
}
